module.exports = __webpack_public_path__ + "img/empty.dce617fe.png";